jQuery.fn.extend({
    confirmSubmit: function (options) {
        const defaults = {
            'type': 'warning',
            'title': 'Atenção',
            'text': 'Tem certeza que deseja continuar?'
        };
        const actual = $.extend({}, defaults, options || {});
        return this.each(function () {
            $(this).submit(function (event, canSubmitForm = false) {

                const form = $(this);

                if (!canSubmitForm) {
                    event.stopImmediatePropagation();
                    swal.fire({
                        title: actual.title,
                        text: actual.text,
                        type: actual.type,
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Sim',
                        cancelButtonText: 'Cancelar'
                    }).then(function (result) {
                        if (result.value) {
                            form.trigger('submit', [{ 'canSubmitForm': true }]);
                        }
                    });

                    return false;
                }

            });
        });
    }
});

jQuery.fn.extend({
    toggleFieldDisabled: function (group) {
        this.change(function () {
            const disabled = $(this).is(":checked") ? null : 'disabled';

            const elements = group.find('input, textbox, select');
            elements.each(function () {
                const element = $(this);
                element.attr('disabled', disabled);
                if (disabled) {
                    if (element.is('input[type=checkbox], input[type=radio]')) {
                        element.prop('checked', false);
                    } else {
                        element.val(null);
                    }
                }
            });

            if (disabled) {
                group.addClass('disabled');
            } else {
                group.removeClass('disabled');
            }
        });
        return this;
    }
});


$(function () {

    $('.action-btn-delete').confirmSubmit({
        'type': 'warning',
        'title': 'Atenção',
        'text': 'Tem certeza que deseja deletar?'
    }).click(function (e) {
        e.stopPropagation();
    });
});

$(function () {

    $('.action-btn-clone').confirmSubmit({
        'type': 'warning',
        'title': 'Atenção',
        'text': 'Tem certeza que deseja clonar as manutenções deste condomínio?'
    }).click(function (e) {
        e.stopPropagation();
    });
});
